var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import { School as SchoolModel } from '@/models/School';
import PageHeader from '@/components/page-header/PageHeader';
import { Sync } from '@/models/Sync';
import LoaderCard from '@/components/loader-card/LoaderCard';
import { RolesEnum } from '@/items/Roles';
let School = class School extends Vue {
    constructor() {
        super(...arguments);
        this.$pageTitle = 'School';
        this.school = new SchoolModel();
        this.syncModel = new Sync();
        this.isLoading = true;
        this.SchoolSettingsTabItems = SchoolSettingsTabItems;
    }
    mounted() {
        this.initialize();
    }
    async initialize() {
        this.isLoading = true;
        await this.fetchSchool();
        this.isLoading = false;
    }
    async fetchSchool() {
        try {
            this.school = await new SchoolModel()
                .include(['settings', 'parnassys'])
                .find(this.$route.params.id);
        }
        catch (error) {
            //
        }
    }
    canViewSetting(setting) {
        switch (setting) {
            case SchoolSettingsTabItems.PROFILE:
            case SchoolSettingsTabItems.TOOLS:
                return (this.user.hasRole([RolesEnum.ROOT, RolesEnum.ADMIN, RolesEnum.TRAINER]) ||
                    this.isTeacherWithExpertRights);
            case SchoolSettingsTabItems.SETTINGS:
            case SchoolSettingsTabItems.STATUS_SETS:
            case SchoolSettingsTabItems.GROUP_SETTINGS:
            case SchoolSettingsTabItems.LVS_SETTINGS:
                return (this.user.hasRole([RolesEnum.ROOT, RolesEnum.ADMIN, RolesEnum.TRAINER]) ||
                    this.isTeacherWithExpertRights);
            case SchoolSettingsTabItems.LOGBOEK:
                return this.isGlobalUser;
            default:
                return false;
        }
    }
    get user() {
        return this.$store.state.Auth;
    }
    get isTeacherWithExpertRights() {
        return this.user && this.user.isTeacherWithExpertRights();
    }
    get isGlobalUser() {
        return !!this.$store.state.Auth.isGlobalUser;
    }
    get url() {
        return '/school-settings';
    }
    get breadcrumbs() {
        if (this.isGlobalUser) {
            return [
                { name: this.$tc('school.title', 2), path: '/admin/schools' },
                { name: this.school.name || '', path: this.$route.path },
            ];
        }
        return [];
    }
};
School = __decorate([
    Component({
        components: {
            PageHeader,
            LoaderCard,
        },
    })
], School);
export default School;
var SchoolSettingsTabItems;
(function (SchoolSettingsTabItems) {
    SchoolSettingsTabItems["PROFILE"] = "profile";
    SchoolSettingsTabItems["TOOLS"] = "tools";
    SchoolSettingsTabItems["SETTINGS"] = "settings";
    SchoolSettingsTabItems["STATUS_SETS"] = "status-sets";
    SchoolSettingsTabItems["GROUP_SETTINGS"] = "group-settings";
    SchoolSettingsTabItems["LVS_SETTINGS"] = "lvs-settings";
    SchoolSettingsTabItems["LOGBOEK"] = "logboek";
})(SchoolSettingsTabItems || (SchoolSettingsTabItems = {}));
